module.exports = __webpack_public_path__ + "static/media/building2.18b8c396.png";